export const MaterialPhoto = ({ image, testId, caption }) => (
  <figure className="min-w-0">
    <img
      data-testid={testId}
      src={image.src}
      srcSet={image.small ? `${image.small} 800w, ${image.src} ${image.width}w` : undefined}
      sizes={image.small ? "(max-width: 767px) calc(100vw - 48px), (max-width: 1279px) 45vw, 560px" : undefined}
      width={image.width}
      height={image.height}
      alt={image.alt}
      loading="lazy"
      decoding="async"
      className="block w-full h-auto object-contain"
    />
    {caption && <figcaption data-testid={`${testId}-caption`} className="mt-3 text-xs leading-relaxed text-[#4A4A4A]">{caption}</figcaption>}
  </figure>
);